// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"22db691c","107":"f4355cb5","437":"b8778794","761":"17982700"}[chunkId] + ".chunk.css";
};